import { pickBy, identity } from 'lodash';
import { objectToQueryString } from 'site-modules/shared/utils/string';

const APPRAISAL_HISTORY_URL = '/appraisal/history/';

export function buildAppraisalHistoryUrl({
  vin = '',
  modsId,
  makeSlug,
  modelSlug,
  year,
  condition = '',
  styleId,
  zipCode,
  mileage,
  optionIds = [],
  isAppExtensionPage = false,
}) {
  const queryParams = objectToQueryString(
    pickBy(
      {
        vin,
        styleId,
        zip: zipCode,
        mileage,
        condition: condition.toUpperCase(),
        optionIds: optionIds.join(','),
        modsId,
      },
      identity
    )
  );
  let appraisalHistoryUrl = APPRAISAL_HISTORY_URL;

  if (makeSlug && modelSlug && year) {
    appraisalHistoryUrl += `${makeSlug}/${modelSlug}/${year}/`;
  }

  if (isAppExtensionPage) {
    // must be appended last
    appraisalHistoryUrl += 'index.app';
  }

  return `${appraisalHistoryUrl}${queryParams ? '?' : ''}${queryParams}`;
}
